import React from 'react'
import { BaseView } from '@/components/base'
import { usePullToRefresh } from './hooks/usePullToRefresh'
import { RefreshIndicator } from './components/RefreshIndicator'
import { PullToRefreshProps } from './types'
import './styles.css'

export const PullToRefresh: React.FC<PullToRefreshProps> = ({
  children,
  onRefresh,
  refreshThreshold = 80,
  maxPullDistance = 120,
  isRefreshing = false,
  refreshIndicator,
  debug = false,
  indicatorStyles,
  disabled = false,
  style,
}) => {
  const {
    containerRef,
    isPulling,
    pullDistance,
    isOverThreshold,
    isRefreshing: internalIsRefreshing,
  } = usePullToRefresh({
    onRefresh,
    refreshThreshold,
    maxPullDistance,
    isRefreshing,
    debug,
    disabled,
  })

  const showIndicator = isPulling || internalIsRefreshing || isRefreshing

  return (
    <div ref={containerRef} className="pullToRefresh" style={style}>
      {showIndicator && (
        <>
          {refreshIndicator || (
            <RefreshIndicator
              pullDistance={pullDistance}
              refreshThreshold={refreshThreshold}
              isOverThreshold={isOverThreshold}
              isRefreshing={internalIsRefreshing || isRefreshing}
              maxPullDistance={maxPullDistance}
              style={indicatorStyles}
            />
          )}
        </>
      )}

      {/* Pull gesture area - invisible overlay */}
      {(isPulling || internalIsRefreshing) && (
        <BaseView
        // style={{
        //   position: 'absolute',
        //   top: 0,
        //   left: 0,
        //   right: 0,
        //   height: Math.max(pullDistance, refreshThreshold * 0.5),
        //   zIndex: 999,
        //   background: `linear-gradient(180deg,
        //     rgba(147, 147, 147, ${Math.min((pullDistance / refreshThreshold) * 0.3, 0.3)}) 0%,
        //     transparent 100%)`,
        //   pointerEvents: 'none',
        //   transition: internalIsRefreshing
        //     ? 'none'
        //     : 'height 0.2s ease-out, background 0.2s ease-out',
        // }}
        />
      )}

      {/* Content */}
      <BaseView
        className={`pullContent ${isPulling ? 'pullContentPulling' : ''} ${internalIsRefreshing || isRefreshing ? 'pullContentRefreshing' : ''}`}
        style={{
          transform: `translateY(${
            isPulling || internalIsRefreshing || isRefreshing
              ? Math.min(pullDistance * 0.3, 20)
              : 0
          }px)`,
          minHeight: '100%',
          transition:
            isPulling || internalIsRefreshing || isRefreshing
              ? 'none'
              : 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        }}
      >
        {children}
      </BaseView>
    </div>
  )
}

// Export types and hooks for external use
export type { PullToRefreshProps } from './types'
export { usePullToRefresh } from './hooks/usePullToRefresh'
